import React from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, RotateCcw } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function CheckoutFailed() {
    const navigate = useNavigate();

    const retry = async () => {
        try {
            const { url } = await api.createCheckout("starter_1000");
            window.location.href = url;
        } catch (e) {
            toast.error(e.message || "Retry failed");
        }
    };

    return (
        <div className="min-h-screen bg-[var(--color-bg)] text-text-main flex items-center justify-center px-6">
            <div
                data-testid="checkout-failed-card"
                className="w-full max-w-lg rounded-2xl border border-[var(--color-alert)]/40 bg-[var(--color-card)] p-8"
            >
                <div className="h-10 w-10 rounded-full bg-[var(--color-alert)]/15 grid place-items-center">
                    <AlertTriangle className="h-5 w-5 text-[var(--color-alert)]" />
                </div>
                <h1 className="mt-5 text-2xl font-semibold tracking-tight">
                    Payment cancelled
                </h1>
                <p className="mt-2 text-sm text-text-secondary">
                    Your card was not charged. You can retry the checkout, or
                    return to the dashboard.
                </p>
                <div className="mt-6 flex flex-wrap gap-3">
                    <button
                        onClick={retry}
                        data-testid="checkout-retry"
                        className="inline-flex items-center gap-2 rounded-full gradient-bg-cta px-5 py-2.5 text-sm font-medium text-white transition-transform duration-150 hover:scale-[0.98]"
                    >
                        <RotateCcw className="h-4 w-4" />
                        Retry checkout
                    </button>
                    <button
                        onClick={() => navigate("/dashboard")}
                        data-testid="checkout-failed-dashboard"
                        className="inline-flex items-center gap-2 rounded-full border border-[var(--color-border)] px-5 py-2.5 text-sm text-text-secondary hover:text-text-main transition-colors"
                    >
                        Back to dashboard
                    </button>
                </div>
            </div>
        </div>
    );
}
